import { BaseRepository } from '../baseRepository'
import { MediaEntityMapper } from './entityMapper'
import MediaApiMapper from './apiMapper'
import Media from '~/models/Media'
import { ApiMedia } from './apitype'

export default class MediaRepository extends BaseRepository {
	private static readonly resource: string = 'v1/medias'

	public static async upload(file: File): Promise<Media> {
		const formData = MediaApiMapper.toApiUploadFile(file)

		const response: ApiMedia | undefined = await this.post(`${this.resource}/`, formData)
		return MediaEntityMapper.toMedia(response!)
	}

	public static async uploadMultiple(files: File[]): Promise<Media[]> {
		const formData = MediaApiMapper.toApiUploadMultipleFiles(files)

		const response: ApiMedia[] | undefined = await this.post(`${this.resource}/bulk/`, formData)
		return MediaEntityMapper.toAllMedias(response!)
	}

	public static async deleteMedia(id: string): Promise<void> {
		await this.delete(`${this.resource}/${id}`)
	}

	public static async getSvg(url: string): Promise<string> {
		if (!this.isSvg(url)) return url
		const response = await fetch(url)
		return await response.text()
	}

	private static isSvg(url: string) {
		return url ? url.slice(-3).toLowerCase() === 'svg' : false
	}
}
